export enum ALabelSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
}

export interface ALabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * The size variant of the label
   */
  size?: ALabelSize;
  /**
   * The text to render
   */
  text: string;
}
